import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#347E96",
  d: "M6.287 6.29.7 11.88A.41.41 0 0 1 0 11.59V6a.41.41 0 0 1 .41-.409h5.588a.41.41 0 0 1 .29.699Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#245869",
  d: "M6.287 5.71.7.12A.41.41 0 0 0 0 .41v5.998h5.998a.41.41 0 0 0 .29-.699Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }